export const LogoMark = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <path d="M10 56V30C10 17.85 19.85 8 32 8s22 9.85 22 22v26" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
    <path d="M6 56h52" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
    <circle cx="32" cy="31" r="6.5" fill="currentColor" />
    <path d="M29.5 35.5h5L37 48H27l2.5-12.5Z" fill="currentColor" />
  </svg>
);

export const Logo = () => (
  <span className="inline-flex items-center gap-2.5">
    <span className="h-9 w-9 rounded-xl bg-[#B4532A] text-[#FBF8F4] grid place-items-center">
      <LogoMark className="h-5 w-5" />
    </span>
    <span className="leading-none">
      <span className="block font-serif text-xl text-[#1F1A17]">HearthVault</span>
      <span className="block font-mono text-[10px] uppercase tracking-[0.25em] text-[#B4532A] mt-1">Hearthside</span>
    </span>
  </span>
);
